module.exports = __webpack_public_path__ + "media/promo/advent/images/garland-2-ad84915b9c9de875597d279c1b03ad24.png";